import { IApplicationState } from '../../types/redux';

export function getFromDeveloperPropsCount(state: IApplicationState) {
  const {
    newbuildingInfo: { fromDeveloperPropsCount },
  } = state;

  return fromDeveloperPropsCount;
}
